import { SafeImage } from '@/components/common/safe-image';
import type { UserSticker } from '@/models/user/custom-sticker';
import cn from '@/utils/merge-class-names';

interface Props {
  sticker: UserSticker;
  isSelected?: boolean;
  className?: string;
  onClick?: () => void;
}

export function StickerItem({ sticker, isSelected, onClick, className }: Props) {
  return (
    <button
      type='button'
      className={cn(
        'm-1 size-16 aspect-square cursor-pointer rounded-lg overflow-hidden bg-base-200',
        'transition-opacity',
        typeof isSelected === 'boolean' && 'relative',
        className,
      )}
      onClick={onClick}>
      <SafeImage
        src={sticker.StickerUrl}
        alt={`sticker-${sticker.Id}`}
        className='size-full object-cover'
        displayType='img'
      />

      {typeof isSelected === 'boolean' && (
        <input
          type='checkbox'
          checked={isSelected}
          readOnly
          className='absolute top-0 right-0 size-5 checkbox-primary checkbox rounded-full border-base-200 z-10'
        />
      )}

      {/*{typeof isSelected === 'boolean' && (*/}
      {/*  <div className='absolute top-0 right-0 w-5 h-5'>*/}
      {/*    {isSelected ? (*/}
      {/*      <div className='w-full h-full rounded-full border-2 border-primary bg-primary flex items-center justify-center text-white'>*/}
      {/*        <svg*/}
      {/*          className='w-3 h-3'*/}
      {/*          fill='currentColor'*/}
      {/*          viewBox='0 0 20 20'>*/}
      {/*          <path*/}
      {/*            fillRule='evenodd'*/}
      {/*            d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'*/}
      {/*            clipRule='evenodd'*/}
      {/*          />*/}
      {/*        </svg>*/}
      {/*      </div>*/}
      {/*    ) : (*/}
      {/*      <img*/}
      {/*        src={checkedIcon}*/}
      {/*        alt='unchecked'*/}
      {/*        className='w-full h-full'*/}
      {/*      />*/}
      {/*    )}*/}
      {/*  </div>*/}
      {/*)}*/}
    </button>
  );
}
